export enum ZsMapOLFeatureProps {
  IS_DRAW_ELEMENT = 'zsMapIsDrawElement',
  DRAW_ELEMENT_TYPE = 'zsMapIsDrawElementType',
  DRAW_ELEMENT_ID = 'zsMapIsDrawElementId',
}
